/*
 *  Class AddToCart
 */
export
default class AddToCart {
    constructor() {
        window.addEventListener('addToCart', this.handleAddToCartCallback.bind(this), false);
    }

    removeErrorMsg() {
      const box = this.querySelector('ul.error-msg');
      if (!box) return;
      box.classList.remove('active');
    }

    unsetError(ctx) {
        ctx.classList.remove('error');
    }

    getI18nProperty(key) {
      const el = document.querySelector('app-addtocart');
      if (el.getAttribute('error-i18n-' + key)) return el.getAttribute('error-i18n-' + key);
      return null;
    }

    setError(errors, ctx) {
        this.setDefault(ctx);
        if (!ctx.querySelector('ul.error-msg')) {
            const node = document.createElement('ul');
            node.classList.add('error-msg');
            ctx.appendChild(node);
        }

        const ul = ctx.querySelector('ul.error-msg');
        ul.innerHTML = '';
        for (let i = 0; i < errors.length; i++) {
            const error = errors[i][0] ? errors[i][0] : errors[i];
            if (!error.key) continue;
            const li = document.createElement('li');
            const i18n = this.getI18nProperty(error.key.split('.').pop());
            ul.innerText = i18n ? i18n : '[no translation] ' + error.message;
            ul.appendChild(li);
        }
        ul.classList.add('active');
        ctx.classList.add('error');
        setTimeout(this.removeErrorMsg.bind(ctx), 4000);
    }

    unsetSuccess(ctx) {
        ctx.classList.remove('success');
    }

    setSuccess(ctx) {
        this.setDefault(ctx);
        ctx.classList.add('success');
    }

    unsetProcessing(ctx) {
        ctx.classList.remove('processing');
    }

    setProcessing(ctx) {
        this.setDefault(ctx);
        ctx.classList.add('processing');
    }

    setDefault(ctx) {
        this.unsetError(ctx);
        this.unsetSuccess(ctx);
        this.unsetProcessing(ctx);
    }

    handleAddToCartCallback(payload) {
        // console.log(payload);
        // console.log(payload.detail.msg.state, payload.detail.context)

        switch (payload.detail.msg.state) {
            case 'error':
                this.setError(payload.detail.msg.errors, payload.detail.context);
                break;
            case 'success':
                this.setSuccess(payload.detail.context);
                break;
            case 'processing':
                this.setProcessing(payload.detail.context);
                break;
            default:
                this.setDefault(payload.detail.context);
        }
    }

    init() {

    }
}
